// src/App.tsx

import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import Home from './pages/LandingPage/Home';
import DocumentationPage from './pages/LandingPage/DocumentationPage';
import FAQ from './pages/LandingPage/FAQ';
import LoginPage from './pages/login/LoginPage';
import Dashboard from './pages/dashboard/Dashboard';
import ScanPage from './pages/scan/ScanPage';
import PrivateRoute from './routes/PrivateRoute';
import Navbar from './components/LandingPage/Navbar/Navbar';
import TopBanner from './components/LandingPage/TopBanner/TopBanner';
import CookieBanner from './components/misc/CookieBanner';

import './i18n';
import './App.css';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import Partners from './pages/LandingPage/Partners';
import VerifyEmailPage from './pages/VerifyEmailPage';
import ResetPasswordForm from './components/Login/ResetPasswordForm';
import PrivacyPolicy from './pages/LandingPage/PrivacyPolicy';
import CookiesPolicy from './pages/LandingPage/CookiesPolicy';
import PageTracker from './components/misc/PageTracker';
import LegalNotice from './pages/LandingPage/LegalNotice';
import NotFound from './pages/NotFound';
import { preloadAssets } from './lib/utils';
import { useIsMobile } from './utils/isMobile';
import ScrollToTop from './components/misc/ScrollToTop';
import UnsubscribePage from './pages/UnsuscribePage';


const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY!);

function Layout({ children }: { children: React.ReactNode }) {
  const location       = useLocation();
  const showUI         = ['/', '/documentation', '/faq', '/partners',
                          '/privacy-policy', '/cookies-policy', '/legal-notice']
                         .includes(location.pathname);

  const [bannerVisible, setBannerVisible] = useState(true);
  const isMobile = useIsMobile();          // ← Llama al hook

  /* alturas */
  const hBanner = bannerVisible ? (isMobile ? 64 : 56) : 0;
  const hNavbar = 80;

  const navTop     = showUI ? hBanner : 0;
  const contentPad = showUI ? hBanner + hNavbar : 0;

  return (
    <>
      {showUI && bannerVisible && (
        <TopBanner onClose={() => setBannerVisible(false)} />
      )}

      {showUI && (
        <Navbar
          fixedTop={navTop}
          hideScan={location.pathname === '/scan'}
        />
      )}

      <div style={{ paddingTop: contentPad }}>{children}</div>
    </>
  );
}


function App() {
  useEffect(() => {
    preloadAssets();
  }, []);

  return (
    <div className="bg-[#0A192F] min-h-screen">
      <Elements stripe={stripePromise}>
        <Router>
          <PageTracker />
          <Layout>
            <ScrollToTop />
            <div className="min-h-screen bg-slate-50">
              <Routes>
                {/* Rutas públicas */}
                <Route path="/" element={<Home />} />
                <Route path="/scan" element={<ScanPage />} />
                <Route path="/documentation" element={<DocumentationPage />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/partners" element={<Partners />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/cookies-policy" element={<CookiesPolicy />} />
                <Route path="/legal-notice" element={<LegalNotice />} />

                <Route path="/login" element={<LoginPage />} />

                <Route path="/payment-success" element={<PaymentSuccessPage />} />
                <Route path="/verify" element={<VerifyEmailPage />} />
                <Route path="/reset-password" element={<ResetPasswordForm />} />
                <Route path="/unsubscribe" element={<UnsubscribePage />} />

                <Route path="*" element={<NotFound />} />

                <Route
                  path="/dashboard"
                  element={
                    <PrivateRoute>
                      <Dashboard />
                    </PrivateRoute>
                  }
                />
              </Routes>
            </div>
            <CookieBanner />
          </Layout>
        </Router>
      </Elements>
    </div>
  );
}

export default App;
